export default function() {
    this.loadJobs()
}
